import request from '../api/request/request'
import AES from '../utils/AES.js' //加密解密AES工具类

export default {
  //  /加密传输
 login(params) {
    return request({
      method: 'post',
      url: '/sys/admin/login',
      data:{
        "username":AES.Encrypt(params.username),
        "password":AES.Encrypt(params.password),
      }
    })
  },

  // 退出
  logout() {
    return request({
      method: 'post',
      url: '/sys/admin/logout',
    })
  },

}







// WEBPACK FOOTER //
// ./src/api/admin.js